<template>
  <div class="payment-method">
    <div class="trial-start" :class="{'campaign': isCampaignTrial, 'trial': !isCampaignTrial}" v-if="isNewTrialUser">
      <div v-if="isChoosePlanVersion && !isDoneChoosingPlan">
        <p class="step">
          ステップ<span>{{currentStep}}/{{numberOfSteps}}</span>
        </p>

        <h1>
          ご利用{{isCampaignTrial ? 'キャンペーン' : 'プラン'}}を選択
        </h1>

        <p class="remaining-steps">
          あと2ステップで登録完了！
        </p>

        <div v-if="!isCampaignTrial" class="about-when-charged">
          <p>
            <img class="check" src="@/assets/check.svg">
            {{trialDuration}}
          </p>
        </div>

        <div class="select-plan">
          <div class="inner">
            <div class="plan-box" :class="{ 'selected': chosenPlan == BIENNIAL_PLAN.duration }"
              @click="() => setChosenPlan(BIENNIAL_PLAN.duration)" 
            >
              <label v-if="isCampaignTrial" class="top-label">
                <div class="plan-title"><span><small>{{ BIENNIAL_PLAN.title }}</small></span></div>

                <div class="pricing">
                  <span class="per-month">アンリミテッドプランが３ヶ月間</span><br />
                  <span class="per-month">通常価格 ¥19,800(税込)/月</span><br />
                  <span class="per-month"><small>【ずっと割】4ヶ月以降も最大3,000円の永続割引</small></span>

                  <div class="plan-amount">
                    <small>▷特別価格 </small>¥{{ BIENNIAL_PLAN.amountUI }}<small>/月</small>
                  </div>
                </div>

                <img class="bottom-check-img" v-if="chosenPlan == BIENNIAL_PLAN.duration" src="@/assets/check_circle_48px_blue.svg">
                <img class="bottom-check-img" v-else                                      src="@/assets/check_circle_48px.svg">

              </label>
              <label v-else class="top-label">
                <p class="plan-appeal">年間プランより2ヶ月分お得！</p>

                <div class="plan-title"><span>年間プラン</span></div>

                <div class="pricing">
                  <span class="per-month">1ヶ月あたり1,650円(税込)</span>

                  <div class="plan-amount">
                    <small>計</small>19,800円<small>(税込)</small>
                  </div>
                </div>

                <img class="bottom-check-img" v-if="chosenPlan == BIENNIAL_PLAN.duration" src="@/assets/check_circle_48px_blue.svg">
                <img class="bottom-check-img" v-else                                      src="@/assets/check_circle_48px.svg">
              </label>
            </div>

            <div class="plan-box" :class="{ 'selected': chosenPlan == ANNUAL_PLAN.duration}"
              @click="() => setChosenPlan(ANNUAL_PLAN.duration)"
            >
              <label v-if="isCampaignTrial" class="bottom-label">
                <div class="plan-title"><span><small>{{ ANNUAL_PLAN.title }}</small></span></div>

                <div class="pricing">
                  <span class="per-month">アンリミテッドプランが３ヶ月間</span><br />
                  <span class="per-month">通常価格 ¥19,800(税込)/月</span>

                  <div class="plan-amount">
                    <small>▷特別価格 </small>¥{{ ANNUAL_PLAN.amountUI }}<small>/月(税込)</small>
                  </div>
                </div>

                <img class="bottom-check-img" v-if="chosenPlan == ANNUAL_PLAN.duration" src="@/assets/check_circle_48px_blue.svg">
                <img class="bottom-check-img" v-else                                    src="@/assets/check_circle_48px.svg">
              </label>
              <label v-else>
                <div class="plan-title"><span>半年プラン</span></div>

                <div v-if="isCampaignTrial" class="pricing">
                  <span class="per-month">プレミアムプランが３ヶ月間</span><br />
                  <span class="per-month">通常価格 ¥19,800(税込)/月</span>

                  <div class="plan-amount">
                    <small>▷特別価格 </small>¥2,980<small>/月(税込)</small>
                  </div>
                </div>

                <div v-else class="pricing">
                  <span class="per-month">1ヶ月あたり1,980円(税込)</span>

                  <div class="plan-amount">
                    <small>計</small>11,800円<small>(税込)</small>
                  </div>
                </div>

                <img class="bottom-check-img" v-if="chosenPlan == ANNUAL_PLAN.duration" src="@/assets/check_circle_48px_blue.svg">
                <img class="bottom-check-img" v-else                                    src="@/assets/check_circle_48px.svg">
              </label>
            </div>
          </div>
        </div>

        <div v-if="isCampaignTrial" class="bonuses">
          <div class="bonus">
            <div class="bonus-title">
              オプション特典
            </div>

            <div class="bonus-content">
              <div class="option-grid-container">
                <div class="option-item"> <span>✓ 毎日1杯ドリンクをもらえる！</span></div>
                <div class="option-item"> <span>✓ 一般より1日早く予約可能！</span></div>
                <div class="option-item"> <span>✓ 交流イベントに無制限で参加可能！</span></div>
                <div class="option-item"> <span>✓ 英会話の予約数が無制限に！</span></div>
                <div class="option-item"> <span>✓ 初心者コーチング（学習プラン作成付）</span></div>
                <div class="option-item"> <span>✓ 初心者を表すビギナーマークの使用</span></div>
              </div>
            </div>

            <img src="@/assets/check_circle_48px_blue.svg">
          </div>

          <div class="bonus">
            <div class="bonus-title">
              入会金
            </div>

            <div class="bonus-content">
              <small>通常 11,000円(税込)</small><br />
              <div><span>▷</span>無料</div>
            </div>

            <img src="@/assets/check_circle_48px_blue.svg">
          </div>
        </div>

        <p v-else class="automatic-start">
          無料体験期間終了後はご選択されたプランへ自動更新されます。
        </p>

        <div v-if="isCampaignTrial" class="agreement">
          <div>
            <label class="container">
              <input type="checkbox" v-model="checkbox1">
              <span class="checkmark"></span>
              特別価格期間後、マンスリープラン(通常価格)での継続が必要となります。
            </label>
            <br />
            <label class="container">
              <input type="checkbox" v-model="checkbox2">
              <span class="checkmark"></span>
              ４ヶ月目以降からお好きなプランへ変更が可能です。(¥6,800~選択可。)
            </label>
            <br />
            <label class="container">
              <input type="checkbox" v-model="checkbox3">
              <span class="checkmark"></span>
              <a href="https://lancul.com/trialcmp_guide" target="_blank">申込内容および重要事項確認書の確認に同意する</a>
            </label>
          </div>
        </div>

        <div v-if="isCampaignTrial" class="button-container">
          <Button @click="() => {if (isNextEnabled) {setDoneChoosingPlan(true)}}" color="gold" :is-invalid="!isNextEnabled">
            次のステップへ
          </Button>
        </div>

        <div v-else class="button-container">
          <button @click="() => setDoneChoosingPlan(true)">
            次のステップへ
          </button>
        </div>
      </div>

      <div v-else> <!-- Light Plan -->
        <p class="step">
          ステップ<span>{{currentStep}}/{{numberOfSteps}}</span>
        </p>

        <h1>
          ご利用{{isCampaignTrial ? 'キャンペーン' : 'プラン'}}確認
        </h1>

        <div class="banner" v-if="isLightTrial">
          <img src="@/assets/campaign_banner_2023.png">
        </div>

        <div class="box">
          <p class="main">{{planTitle}}</p>
          <p class="sub" v-if="!isChoosePlanVersion">（30日間使い放題トライアル入会プラン）</p>
          <div class="line" />

          <p class="amount">{{isCampaignTrial ? '特別価格' : '金額'}} <span>{{planPrice}}</span><strong>{{isCampaignTrial ? '円/月' : '円'}}（税込）</strong></p>
        </div>

        <div v-if="!isCampaignTrial" class="about-trial">
          <div v-if="isLightTrial">
            <h1> 重要事項のご案内 </h1>
            <label class="container" v-if="trialType != 'elearning'">
              <input type="checkbox" v-model="trialCheckbox">
              <span class="checkmark"></span>
              <a href="https://lancul.com/blog/trial_guide" target="_blank">購入商品の内容および重要事項確認書の内容</a>に同意する
            </label>
          </div>
          <div v-else>
            <img class="check" src="@/assets/check.svg">
            {{trialDuration}}
          </div>
        </div>

        <h1>
          支払い情報の入力
        </h1>
        <p class="explanation">
          今回のお支払い額は{{planPriceToday}}円です。<br>
          {{(this.isLightTrial) ? '' : '今後の'}}お支払い方法を設定して下さい。
        </p>

        <div class="until-when">
          {{untilWhen}}
        </div>

        <div id="card-element"></div>

        <div class="add-new">
          <p v-if="!showOnlyAddCardForm" class="title">新しいカードを登録する</p>

          <div class="button-container">
            <Button @click="$emit('add', cardElement, !isCampaignTrial ? payPeriod : null, isCampaignTrial ? campaignId : null)" :disabled="validateTrialCheckbox" :is-invalid="validateTrialCheckbox">
              登録してはじめる
            </Button>
          </div>

          <div v-if="isChoosePlanVersion" class="go-back" @click="() => {setDoneChoosingPlan(false)}">戻る</div>
        </div>
      </div>
    </div>

    <div v-else>
      <HeaderBack page-name="支払い方法" @back="$emit('back')" />

      <div v-if="!showOnlyAddCardForm" class="change-default">
        <div class="default-card">
          <CreditCard v-if="isDefaultCardSet" class="default-card"
            :brand="defaultCardBrand"
            :last4="defaultCardLast4"
            :is-i-phone="isIPhone"
            size="large"
          />
          <p v-else>
            支払い方法を設定してください
          </p>
        </div>

        <p class="title">{{isDefaultCardSet ? '他に登録したカードに変更する' : 'すでに登録したカードにする'}}</p>

        <div class="other-cards">
          <div v-for="({id, brand, last4}, index) in creditCards" :key="index" class="other-card">
            <input
              type="radio"
              :id="id"
              :value="id"
              v-model="idOfCardToSet"
            />

            <CreditCardLabel class="card"
              :brand="brand"
              :last4="last4"
              :credit-card-id="id"
              :is-i-phone="isIPhone"
            />
          </div>

          <div class="button-container">
            <button
              :class="{ disabled: !idOfCardToSet }"
              @click="() => {if (idOfCardToSet) {$emit('set', idOfCardToSet)}}"
            >
              {{isDefaultCardSet ? '変更' : '設定'}}
            </button>
          </div>
        </div>
      </div>

      <div class="add-new">
        <p v-if="!showOnlyAddCardForm" class="title">新しいカードを登録する</p>

        <div id="card-element"></div>

        <div class="button-container">
          <button @click="$emit('add', cardElement)">
            {{isNewTrialUser ? '登録してはじめる' : '登録'}}
          </button>
        </div>
      </div>
    </div>
    </div>
</template>

<script>
import HeaderBack from '@/components/helpers/HeaderBack.vue'
import CreditCard from '@/components/account/helpers/CreditCard.vue'
import CreditCardLabel from '@/components/account/helpers/CreditCardLabel.vue'
import Button from '@/components/signup/Button.vue'
import { format, add, isBefore } from 'date-fns';

const BIENNIAL_PLAN = {
  title: '【ずっと割】12周年記念キャンペーン',
  duration: 24,
  amount: 2980,
  amountUI: '2,980',
};

const ANNUAL_PLAN = {
  title: '12周年記念キャンペーン',
  duration: 12,
  amount: 2980,
  amountUI: '2,980',
};

const LIGHT_PLAN_LABEL = 'ライトプラン'

export default {
  name: 'AddCreditCard',

  setup() {
    return {
      BIENNIAL_PLAN,
      ANNUAL_PLAN,
      LIGHT_PLAN_LABEL
    }
  },

  components: {
    HeaderBack,
    CreditCard,
    CreditCardLabel,
    Button
  },

  props: {
    stripe: {
      type: Object,
      required: true
    },

    isDefaultCardSet: {
      type: Boolean,
      required: true
    },

    defaultCardBrand: {
      type: String,
      required: true
    },

    defaultCardLast4: {
      type: String,
      required: true
    },

    creditCards: {
      type: Array,
      required: true
    },

    isNewTrialUser: {
      type: Boolean,
      required: true
    },

    isChoosePlanVersion: {
      type: Boolean,
      required: true
    },

    isIPhone: {
      type: Boolean,
      default: false
    },

    isCampaignTrial: {
      type: Boolean,
      required: true
    },

    trialType: {
      type: String,
      required: false
    }
  },

  data() {
    return {
      cardElement: null,
      idOfCardToSet: null,
      isDoneChoosingPlan: false,
      chosenPlan: 24,
      checkbox1: false,
      checkbox2: false,
      checkbox3: false,
      trialCheckbox: false,
      basePaymentStartDate: new Date('July 1, 2022')
    }
  },

  computed: {
    showOnlyAddCardForm() {
      return !(this.isDefaultCardSet || this.creditCards.length !== 0)
    },

    trialDuration() {
      if (this.trialType == "elearning") {
        return "7日間の無料体験中（5日目の23時59分まで）に自動更新を停止すれば料金は請求されません。"
      } else {
        return "7日間の無料体験中（5日目の23時59分まで）に自動更新を停止すれば料金は請求されません。"
      }
    },

    untilWhen() {
      if (this.trialType == "elearning"){
        return format(add(new Date(), {days: 7}),"yyyy年MM月dd日")
      }

      if (this.isLightTrial) {
        return format(new Date(),"yyyy年MM月dd日")
      }

      return format(
        this.isCampaignTrial ?
          isBefore(new Date(), this.basePaymentStartDate) ? this.basePaymentStartDate : add(new Date(), {days: 0})
        :
          add(new Date(), {days: 7}),"yyyy年MM月dd日")

    },

    payPeriod() {
      return this.chosenPlan
    },

    campaignId() {
      return this.chosenPlan == 12 ? 10 : 20
    },

    currentStep() {
      if (this.isChoosePlanVersion) {
        return this.isDoneChoosingPlan ? 3 : 2
      } else {
        return 2
      }
    },

    numberOfSteps() {
      return this.isChoosePlanVersion ? 3 : 2
    },

    planPrice() {
      if (this.isChoosePlanVersion) {
        return this.chosenPlan == 24 ?
            (this.isCampaignTrial ? BIENNIAL_PLAN.amountUI : '19,800')
          :
            (this.isCampaignTrial ? ANNUAL_PLAN.amountUI : '11,800')
      } else {
        return '1,100'
      }
    },

    planTitle() {
      if (this.isChoosePlanVersion) {
        return this.chosenPlan == 24 ?
            (this.isCampaignTrial ? BIENNIAL_PLAN.title : '年間プラン')
          :
            (this.isCampaignTrial ? ANNUAL_PLAN.title : '半年プラン')
      } else {
        return LIGHT_PLAN_LABEL
      }
    },

    planPriceToday() {
      if (this.isLightTrial) {
        return '1,100'
      } else {
        return '2,980'
      }
    },

    isNextEnabled() {
      return this.checkbox1 && this.checkbox2 && this.checkbox3
    },

    isLightTrial() {
      if (this.trialType === "elearning" || this.isChoosePlanVersion) {
        return false
      }
      else {
        return true
      }
    },

    validateTrialCheckbox() {
      if (this.isLightTrial && !this.trialCheckbox){
        return true
      }
      return false
    }
  },

  mounted() {
    if (!this.isNewTrialUser || !this.isChoosePlanVersion) {
      this.mountCardElement()
    }
  },
  
  watch: {
    isDoneChoosingPlan() {
      if (this.isDoneChoosingPlan) {
        setTimeout(() => {this.mountCardElement()}, 100)
      }
    }
  },

  methods: {
    mountCardElement() {
      var elements = this.stripe.elements()
      this.cardElement = elements.create('card')
      this.cardElement.mount('#card-element')
    },

    setChosenPlan(plan) {
      this.chosenPlan = plan
    },

    setDoneChoosingPlan(done) {
      this.isDoneChoosingPlan = done
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style scoped>
.payment-method .title {
  font-size: 14px;
  line-height: 21px;
  font-weight: 600;
  margin-top: 60px;
  margin-bottom: 10px;
}

.payment-method .default-card {
  display: flex;
  justify-content: center;
}

.payment-method .other-cards .card {
  margin-top: 0.5px;
  margin-left: 5px;
}

.payment-method .other-cards .other-card + .other-card {
  margin-top: 20px;
}

.payment-method .other-cards .other-card {
  display: flex;
}

.payment-method .button-container {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}

.payment-method .button-container button {
  min-width: 100px;
  height: 36px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 1.12px;
  color: white;
  background-color: #147efb;
  border: 2px solid #147efb;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.2);
}

.payment-method .button-container button.disabled {
  opacity: 0.25;
}

.payment-method .add-new {
  margin-bottom: 120px;
}

.banner {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.banner img {
  width: 100%;
}

.bottom-check-img {
  position: absolute;
  bottom: 0;
  width: 24px;
  height: 24px;
  margin-bottom: 16px;
}

.option-grid-container {
  margin-top: 4px;
  display: grid;
  grid-template-columns: 1fr 1fr;
}

.option-item {
  display: flex;
  align-items: center;
}

.trial-start p.step {
  font-size: 14px;
  line-height: 21px;
  color: black;
  margin-bottom: 10px;
}

.trial-start p.step > span {
  font-weight: 600;
  margin-left: 10px;
}

.trial-start h1 {
  font-size: 24px;
  line-height: 36px;
  font-weight: 600;
}

.trial-start p {
  font-size: 16px;
  line-height: 24px;
}

.trial-start .remaining-steps {
  margin-bottom: 24px;
  font-size: 20px;
  line-height: 30px;
}

.trial-start .about-when-charged {
  margin-bottom: 24px;
}

.trial-start .select-plan .plan-box {
  position: relative;
  text-align: center;
  width: 50%;
  margin: 0 10px;
  cursor: pointer;
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}

.trial-start .select-plan .plan-box label {
  position: relative;
  width: 100%;
  max-width: 410px;
  padding: 28px 0 0;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  display: inline-block;
  color: #000;
  background: #f0f0f0;
  margin: 4px 0;
  box-sizing: border-box;
}

.trial-start.trial .select-plan .plan-box label {
  height: 176px;
}

.trial-start .select-plan .plan-box.selected label {
  background: #dde3ec;
  color: #0e357f;
}

.trial-start .select-plan .plan-box label .plan-appeal {
  position: absolute;
  top: -12px;
  z-index: 2;
  width: 80%;
  height: 24px;
  margin: 0 10%;
  line-height: 1.8;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.02rem;
  color: #fff;
  padding-top: 2px;
  background: #0e357f;
  border-radius: 30px;
}

.trial-start.campaign .select-plan .plan-box label .plan-appeal {
  width: 90%;
  margin: 0 5%;
}

.trial-start .select-plan .plan-box label .plan-title > span {
  font-weight: 600;
  font-size: 25px;
  height: 36px;
  text-align: center;
}

.trial-start .select-plan .plan-box label .pricing {
  margin-top: 6px;
}

.trial-start .select-plan .plan-box label .pricing > span {
  font-size: 13px;
  line-height: 19.5px;
}

.trial-start .select-plan .plan-box label .pricing .plan-amount {
  font-weight: 600;
  font-size: 28px;
}

.trial-start.trial .select-plan .plan-box label .pricing .plan-amount {
  height: 36px;
}

.trial-start .select-plan .plan-box label .pricing .plan-amount small {
  font-size: 14px;
}

.trial-start .select-plan .plan-box label img {
  width: 24px;
  height: 24px;
  margin-top: 10px;
}

.trial-start.campaign .select-plan .plan-box label img {
  margin-top: 3px;
}

.trial-start .bonuses {
  border: 1px solid #dbdbdb;
  border-radius: 15px;
  margin: 24px 10px 0;
  padding: 10px 10px;
}

.trial-start .bonuses {
  font-weight: 600;
  font-size: 25px;
  line-height: 25px;
  text-align: center;
  background: #dde3ec;
  color: #0e357f;
  padding: 20px;
}

.trial-start .bonuses .bonus small {
  font-size: 13px;
}

.trial-start .bonuses .bonus span {
  font-weight: 600;
  font-size: 14px;
}

.trial-start .bonuses img {
  width: 24px;
  height: 24px;
  margin-top: 10px;
}

.trial-start .automatic-start {
  margin: 16px 10px 60px;
}

.trial-start .agreement {
  display: flex;
  justify-content: center;
  margin-top: 24px;
}

.trial-start .agreement .container {
  font-size: 12px;
  line-height: 18px;
}

.trial-start .box {
  padding: 20px;
  width: 100%;
  margin-bottom: 24px;
  margin-top: 24px;
  border: 1px solid #dbdbdb;
  box-sizing: border-box;
}

.trial-start .box p {
  font-size: 14px;
  line-height: 21px;
}

.trial-start .box p.main {
  font-weight: bolder;
  color: black;
}

.trial-start .box p.sub {
  color: #858585;
}

.trial-start .box .line {
  margin-top: 10px;
  height: 1px;
  background-color: #B6B6B6;
}

.trial-start .box .amount {
  margin-top: 20px;
  text-align: right;
}

.trial-start .box .amount span {
  font-size: 30px;
  font-weight: 700;
}

.trial-start img.check {
  width: 20px;
  height: 20px;
}

.trial-start .until-when {
  font-size: 18px;
  color: #0e357f;
  margin: 18px 0 38px;
  line-height: 18px;
  text-align: center;
  background-color: #dde3ec;
  padding: 20px;
  font-weight: 600;
}

.trial-start .button-container {
  margin-top: 60px;
}

.trial-start.campaign .select-plan .plan-box label {
  height: 250px;
}

.trial-start.campaign .button-container {
  margin-top: 36px;
}

.trial-start .button-container button {
  min-width: 100px;
  height: 36px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 1.12px;
  color: white;
  background-color: #0E357F;
  border: 2px solid #0E357F;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.2);

  width: 80%;
  max-width: 335px;
  height: 40px;
  font-size: 15px;
  line-height: 22.5px;
  font-weight: 700;
}

.trial-start .go-back {
  text-align: center;
  color: #0e357f;
  font-weight: 700;
  margin: 24px auto;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content;
  cursor: pointer;
}

@media (min-width: 440px) {
  .sm-only {
    display: none;
  }
}

@media (max-width: 599px) {
  .trial-start .select-plan .plan-box {
    width: 100%;
    margin: 0;
  }

  .trial-start .select-plan .plan-box label {
    max-width: initial;
    padding: 24px 0 0;
    border-radius: 6px;
    font-size: 12px;
    margin-bottom: 20px;
    display: flex;
  }

  .trial-start.campaign .select-plan .plan-box label {
    padding: 24px 0 0 24px;
  }

  .trial-start.trial .select-plan .plan-box label {
    height: 95px;
  }

  .trial-start .select-plan .plan-box label .plan-appeal {
    font-size: 12px;
    width: 60%;
    left: 0;
    right: 0;
    margin: auto;
  }

  .trial-start .select-plan .plan-box label .plan-title {
    width: 120px;
    margin: 10px 0 0;
    box-sizing: border-box;
  }

  .trial-start.campaign .select-plan .plan-box label .plan-title {
    margin-top: 5px;
  }

  .trial-start .select-plan .plan-box label .plan-title > span {
    font-size: 19px;
  }

  .trial-start .select-plan .plan-box label .pricing {
    width: 235px;
    margin: 0 40px 0 0;
  }

  .trial-start.campaign .select-plan .plan-box label .pricing {
    margin: 0;
  }

  .trial-start .select-plan .plan-box label .pricing > span {
    font-size: 12px;
  }

  .trial-start .select-plan .plan-box label .pricing .plan-amount {
    font-size: 20px;
  }

  .trial-start .select-plan .plan-box label img {
    margin: 0;
    position: absolute;
    top: 32px;
    right: 16px;
  }

  .trial-start.campaign .bonuses {
    padding: 24px 16px 24px 24px;
    margin: 0;
  }

  .trial-start.campaign .bonuses .bonus {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .trial-start.campaign .bonuses .bonus .bonus-title {
    width: 140px;
    display: flex;
    justify-content: center;
  }

  .trial-start.campaign .bonuses {
    margin-top: 45px;
    font-size: 19px;
  }

  .trial-start.campaign .bonuses p {
    width: 128px;
    font-size: 12.5px;
    line-height: 18.75px;
  }

  .trial-start.campaign .select-plan .plan-box label {
    height: revert !important;
    padding: 24px 10px;
    justify-content: space-around;
    align-items: center;
  }

  .trial-start.campaign .select-plan .plan-box label img {
    position: revert;
  }

  .trial-start .bonuses .bonus + .bonus {
    margin-top: 20px;
  }

  .trial-start .bonuses img {
    margin-top: 0px;
  }

  .option-grid-container {
    grid-template-columns: 1fr;
  }

  @media (min-width: 450px) {
    .trial-start .select-plan .plan-box label {
      justify-content: space-evenly;
    }
  }
}

@media (min-width: 600px) {
  .trial-start .select-plan .inner {
    display: flex;
    justify-content: space-between;
  }

  .trial-start .bonuses {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding-bottom: 48px;
  }

  .trial-start .bonus {
    min-height: 84px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .trial-start .bonus img {
    position: absolute;
    bottom: -34px;
    left: calc(50% - 12px);
  }
}

@media (max-width: 350px) {
  .trial-start .about-when-charged > p {
    font-size: 15px;
  }

  .trial-start .select-plan .plan-box label .plan-appeal {
    width: 65%;
  }

  .trial-start .select-plan .plan-box label .plan-title {
    width: 96px;
  }

  .trial-start .select-plan .plan-box label .plan-title > span {
    font-size: 16px;
  }

  .trial-start .select-plan .plan-box label img {
    right: 10px;
  }

  .option-grid-container {
    grid-template-columns: 1fr;
  }
}

</style>
